import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";

export const ADMIN_API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  useEffect(() => {
    axios
      .get(`${ADMIN_API}/auth/me`, { withCredentials: true })
      .then((r) => setAdmin(r.data))
      .catch(() => setAdmin(false));
  }, []);
  return <AdminAuthContext.Provider value={{ admin, setAdmin }}>{children}</AdminAuthContext.Provider>;
};

export const useAdminAuth = () => useContext(AdminAuthContext);

export const ProtectedAdmin = ({ children }) => {
  const { admin } = useAdminAuth();
  if (admin === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-ink" data-testid="admin-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand border-t-transparent" />
      </div>
    );
  }
  if (admin === false) return <Navigate to="/admin/login" replace />;
  return children;
};
